'use client';

import { VELOCITY_CUSTOM_WALLET_ICONS } from 'src/constants/wallets';
import { VelocityTheme } from 'src/environmentVariables/EnvironmentVariableTypes';
import useVelocityTheme from 'src/hooks/useVelocityTheme';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';

const useCurrentWalletIconSrc = () => {
	const walletState = useVelocityStore((s) => s.wallet);

	const isLightTheme = useVelocityTheme() === VelocityTheme.light;

	if (walletState.isAppKit)
		return isLightTheme
			? VELOCITY_CUSTOM_WALLET_ICONS.APPKIT_WALLET_ADAPTER.light
			: VELOCITY_CUSTOM_WALLET_ICONS.APPKIT_WALLET_ADAPTER.dark;

	if (walletState.isPrivyNativeAuth) {
		return isLightTheme
			? VELOCITY_CUSTOM_WALLET_ICONS.PRIVY_NATIVE_WALLET_ADAPTER.light
			: VELOCITY_CUSTOM_WALLET_ICONS.PRIVY_NATIVE_WALLET_ADAPTER.dark;
	}

	return walletState?.current?.adapter?.icon;
};

export default useCurrentWalletIconSrc;
